import { type FeedbackDialogProps } from '@ori-ui/components';
import { z } from 'zod';

import { useNewsletterDialogContext } from './components';
import { SubscriptionProcessStatus } from './types';

export const getColorFromStatus = (status: SubscriptionProcessStatus): FeedbackDialogProps['color'] => {
  switch (status) {
    case SubscriptionProcessStatus.Subscribed:
      return 'success';
    case SubscriptionProcessStatus.Failed:
      return 'error';
    default:
      return 'info';
  }
};

export const useValidationSchema = () => {
  const { content } = useNewsletterDialogContext();

  const newsletterDialogValidationSchema = z.object({
    email: z.string().email(content.invalidEmailLabel),
  });

  return { newsletterDialogValidationSchema };
};
